<template>
  <PageWrapper :isLoading="isLoading" isDense isTransparent>
    <template #title> ایجاد کلاس ترمیک جدید </template>
    <PageWrapper isChildWrapper>
      <template #title> تنظیمات کلی </template>
      <BRow>
        <BCol cols="12" md="6">
          <TextInput
              inputId="termicCourseName"
              inputLabel="عنوان کلاس"
              inputPlaceholder="کلاس ترمیک آیلتس مقدماتی"
              v-model="termicCoursePayload.termicCourseName"
          ></TextInput>
        </BCol>
        <BCol cols="12" md="6">
          <LanguagePicker
              placeHolder="زبان کلاس ترمیک"
              @getLanguage="setTermicCourseLanguage"
          ></LanguagePicker>
        </BCol>

        <BCol cols="12" md="6">
          <MasterPicker @getMaster="setMasterUserId"></MasterPicker>
        </BCol>

        <BCol cols="12" md="6">
          <TextInput
              inputId="sessions"
              inputLabel="تعداد جلسات"
              inputPlaceholder="8"
              inputMode="numeric"
              v-model="termicCoursePayload.sessions"
              type="number"
          >
            <template #append> جلسه </template>
          </TextInput>
        </BCol>

        <BCol cols="12">
          <TextInput
              inputId="masterIncome"
              inputLabel="درآمد استاد"
              inputPlaceholder="200,000"
              inputMode="numeric"
              v-model="formattedMasterIncome"
              type="text"
          >
            <template #append> تومان </template>
          </TextInput>
        </BCol>

        <BCol cols="12" md="6">
          <BRow>
            <BCol cols="6">
              <CustomDatePicker
                  type="time"
                  inputId="startTime"
                  inputLabel="ساعت شروع کلاس"
                  inputPlaceholder="14:30"
                  @getSelectedDate="setTermicCourseStartTime"
              ></CustomDatePicker>
            </BCol>
            <BCol cols="6">
              <CustomDatePicker
                  type="time"
                  inputId="endTime"
                  inputLabel="ساعت پایان کلاس"
                  inputPlaceholder="16:30"
                  @getSelectedDate="setTermicCourseEndTime"
              ></CustomDatePicker>
            </BCol>
          </BRow>
        </BCol>
        <BCol cols="12" md="6">
          <WeekDaysCheckBoxGroup
              inputLabel="روز های برگزاری کلاس"
              v-model="termicCoursePayload.days"
          ></WeekDaysCheckBoxGroup>
        </BCol>
      </BRow>
    </PageWrapper>

    <PageWrapper isChildWrapper>
      <template #title> تنظیمات زبان آموز </template>
      <BRow>
        <BCol cols="12" md="6">
          <TextInput
              inputId="minUserCapacity"
              inputLabel="حداقل تعداد شرکت کننده"
              inputPlaceholder="4"
              inputMode="numeric"
              v-model="termicCoursePayload.minUserCapacity"
              type="number"
          >
            <template #append> نفر </template>
          </TextInput>
        </BCol>

        <BCol cols="12" md="6">
          <TextInput
              inputId="maxUserCapacity"
              inputLabel="حداکثر تعداد شرکت کننده"
              inputPlaceholder="8"
              inputMode="numeric"
              v-model="termicCoursePayload.maxUserCapacity"
              type="number"
          >
            <template #append> نفر </template>
          </TextInput>
        </BCol>

        <BCol cols="12" md="6">
          <TextInput
              inputId="price"
              inputLabel="قیمت کلاس ترمیک"
              inputPlaceholder="1,000,000"
              inputMode="numeric"
              v-model="formattedTermicCoursePrice"
              type="text"
          >
            <template #append> تومان </template>
          </TextInput>
        </BCol>

        <BCol cols="12" md="6">
          <BRow>
            <BCol cols="6">
              <TextInput
                  inputId="discountPrice"
                  inputLabel="قیمت کلاس ترمیک با تخفیف"
                  inputPlaceholder="700,000"
                  inputMode="numeric"
                  v-model="formattedTermicCourseDiscountPrice"
                  type="text"
              >
                <template #append> تومان </template>
              </TextInput>
            </BCol>
            <BCol cols="6">
              <TextInput
                  inputId="discountPriceConditionCount"
                  inputLabel="تعداد نفرات شامل تخفیف"
                  inputPlaceholder="5"
                  inputMode="numeric"
                  v-model="termicCoursePayload.discountPriceConditionCount"
                  type="number"
              >
                <template #append> نفر </template>
              </TextInput>
            </BCol>
          </BRow>
        </BCol>
      </BRow>
    </PageWrapper>

    <PageWrapper isChildWrapper>
      <template #title> تنظیمات عمومی </template>
      <BRow>
        <BCol cols="12">
          <BFormGroup label="تصویر نمایشی کلاس" label-for="imageFile">
            <BFormFile
                v-model="uploadImagePayload.imageFile"
                ref="imageFile"
                id="imageFile"
                accept=".jpg,.jpeg,.png"
                @input="handleImageFile"
            ></BFormFile>
          </BFormGroup>
        </BCol>
        <BCol cols="12" class="position-relative" v-if="imagePreview">
          <BImg
              v-if="imagePreview"
              rounded
              class="custom-image"
              center
              fluid
              :src="imagePreview"
          ></BImg>
          <BButton
              size="sm"
              variant="transparent"
              class="custom-delete-btn"
              @click="deletePreviewImage"
          >
            <FeatherIcon size="40" class="text-danger" icon="Trash2Icon" />
          </BButton>
        </BCol>
        <BCol cols="12">
          <CustomEditor
              label="توضیحات کلاس ترمیک"
              v-model="termicCoursePayload.termicCourseDescription"
          ></CustomEditor>
        </BCol>
        <BCol cols="12" class="d-flex align-items-center justify-content-end">
          <BButton @click="createANewTermicCourse" variant="success">
            ایجاد کلاس ترمیک
          </BButton>
        </BCol>
      </BRow>
    </PageWrapper>

    <BModal
        id="conflict-modal"
        title="تداخل زمانی کلاس‌ها"
        ok-only
        ok-title="باشه"
        size="lg"
        centered
        scrollable
    >
      <div
          v-for="(item, index) in termicCoursePayload.days
          .slice()
          .sort(
            (a, b) =>
              [6, 0, 1, 2, 3, 4, 5].indexOf(a) -
              [6, 0, 1, 2, 3, 4, 5].indexOf(b)
          )"
          :key="index"
          class="d-flex border-bottom py-1"
      >
        <span style="width: 100px">{{ weekdays[item].fa }}</span>

        <div class="d-flex flex-wrap" style="gap: 12px">
          <b-badge
              v-for="value in splitInto10MinIntervals(
              termicCoursePayload.startTime,
              termicCoursePayload.endTime
            )"
              :key="value"
              class="font-weight-normal text-center"
              :variant="
              conflicts.some(
                (conflict) =>
                  conflict.dayWeek == weekdays[item].en &&
                  conflict.startDate.slice(11, 16) == value.split('-')[0]
              )
                ? 'danger'
                : 'success'
            "
              style="width: 120px"
          >
            <h4 style="color: white; margin: 0">
              {{ value.split("-").join(" تا ") }}
            </h4>
          </b-badge>
        </div>
      </div>
    </BModal>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import WeekDaysCheckBoxGroup from "@/views/components/TermicCourses/WeekDaysCheckBoxGroup.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import CustomEditor from "@/views/components/Utils/CustomEditor.vue";
import {
  BRow,
  BCol,
  BButton,
  BImg,
  BFormGroup,
  BFormFile,
  BBadge,
} from "bootstrap-vue";
import { CreateTermicCourse } from "@/libs/Api/TermicCourses";
import { UploadImage } from "@/libs/Api/Uploader";

export default {
  components: {
    PageWrapper,
    TextInput,
    CustomDatePicker,
    LanguagePicker,
    BRow,
    BCol,
    BFormGroup,
    BFormFile,
    BButton,
    BImg,
    MasterPicker,
    WeekDaysCheckBoxGroup,
    CustomEditor,
    BBadge,
  },
  data: () => ({
    isLoading: false,
    uploadImagePayload: {
      imageFile: null,
      fileType: 0,
      title: null,
      alt: null,
      description: null,
    },
    imagePreview: null,
    termicCoursePayload: {
      termicCourseName: null,
      languageId: null,
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      minUserCapacity: null,
      maxUserCapacity: null,
      sessions: null,
      imageUrl: null,
      masterUserId: null,
      price: null,
      discountPrice: null,
      discountPriceConditionCount: null,
      masterIncome: null,
      days: [],
      termicCourseDescription: null,
    },

    weekdays: {
      0: { fa: "یکشنبه", en: "Sunday" },
      1: { fa: "دوشنبه", en: "Monday" },
      2: { fa: "سه‌شنبه", en: "Tuesday" },
      3: { fa: "چهارشنبه", en: "Wednesday" },
      4: { fa: "پنجشنبه", en: "Thursday" },
      5: { fa: "جمعه", en: "Friday" },
      6: { fa: "شنبه", en: "Saturday" },
    },
    conflicts: [],
  }),
  computed: {
    formattedTermicCoursePrice: {
      get() {
        return this.termicCoursePayload.price;
      },
      set(newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.termicCoursePayload.price = this.convertNumbers2English(newValue)
              .toString()
              .replaceAll(",", "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // Remove all characters that are NOT number
          this.termicCoursePayload.price =
              this.termicCoursePayload.price.replace(
                  /[a-zA-Z+*!@#$%^&*()_;:'"|<>/?{}\u0600-\u06EC/\-/\.]/g,
                  ""
              );
        } else if (!newValue || newValue === "") {
          this.termicCoursePayload.price = "";
        }
      },
    },
    formattedTermicCourseDiscountPrice: {
      get() {
        return this.termicCoursePayload.discountPrice;
      },
      set(newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.termicCoursePayload.discountPrice = this.convertNumbers2English(
              newValue
          )
              .toString()
              .replaceAll(",", "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // Remove all characters that are NOT number
          this.termicCoursePayload.discountPrice =
              this.termicCoursePayload.discountPrice.replace(
                  /[a-zA-Z+*!@#$%^&*()_;:'"|<>/?{}\u0600-\u06EC/\-/\.]/g,
                  ""
              );
        } else if (!newValue || newValue === "") {
          this.termicCoursePayload.discountPrice = "";
        }
      },
    },

    formattedMasterIncome: {
      get() {
        return this.termicCoursePayload.masterIncome;
      },
      set(newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.termicCoursePayload.masterIncome = this.convertNumbers2English(
              newValue
          )
              .toString()
              .replaceAll(",", "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // Remove all characters that are NOT number
          this.termicCoursePayload.masterIncome =
              this.termicCoursePayload.masterIncome.replace(
                  /[a-zA-Z+*!@#$%^&*()_;:'"|<>/?{}\u0600-\u06EC/\-/\.]/g,
                  ""
              );
        } else if (!newValue || newValue === "") {
          this.termicCoursePayload.masterIncome = "";
        }
      },
    },
  },
  methods: {
    async generateImageFormData() {
      return new Promise((resolve, reject) => {
        this.uploadImagePayload.title =
            this.termicCoursePayload.termicCourseName;
        this.uploadImagePayload.alt = this.termicCoursePayload.termicCourseName;
        this.uploadImagePayload.description =
            this.termicCoursePayload.termicCourseDescription;

        const myFormData = new FormData();
        Object.keys(this.uploadImagePayload).forEach((key) => {
          myFormData.append(key, this.uploadImagePayload[key]);
        });
        resolve(myFormData);
      });
    },
    handleImageFile() {
      if (this.uploadImagePayload.imageFile) {
        this.imagePreview = URL.createObjectURL(
            this.uploadImagePayload.imageFile
        );
      }
    },
    deletePreviewImage() {
      if (this.uploadImagePayload && this.uploadImagePayload.imageFile) {
        URL.revokeObjectURL(this.imagePreview);
        this.imagePreview = null;
        this.uploadImagePayload.imageFile = null;
        if (this.$refs.imageFile && this.$refs.imageFile) {
          this.$refs.imageFile.reset();
        }
      }
    },
    async uploadTermicCourseImage() {
      try {
        this.isLoading = true;
        const _this = this;
        const uploadImage = new UploadImage(_this);
        uploadImage.setFormData(await _this.generateImageFormData());
        await uploadImage.sendFormData((res) => {
          if (res.data.url) {
            this.termicCoursePayload.imageUrl = res.data.url;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setTermicCourseLanguage(languageId) {
      this.termicCoursePayload.languageId = languageId;
    },
    setTermicCourseStartDate(startDate) {
      this.termicCoursePayload.startDate = new Date(startDate).toISOString();
    },
    setTermicCourseEndDate(endDate) {
      this.termicCoursePayload.endDate = new Date(endDate).toISOString();
    },
    setTermicCourseStartTime(startTime) {
      this.termicCoursePayload.startTime = new Date(startTime).toISOString();
    },
    setTermicCourseEndTime(endTime) {
      this.termicCoursePayload.endTime = new Date(endTime).toISOString();
    },
    setMasterUserId(master) {
      this.termicCoursePayload.masterUserId = master.userId;
    },
    convertNumbers2English(number) {
      return number.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (c) {
        return c.charCodeAt(0) & 0xf;
      });
    },
    generateTermicCoursePayload() {
      // This method is used to sanitize payload, like removing
      // commas from price, etc.
      const newPayload = { ...this.termicCoursePayload };

      if (newPayload.price)
        newPayload.price = newPayload.price.replaceAll(",", "");

      if (newPayload.discountPrice)
        newPayload.discountPrice = newPayload.discountPrice.replaceAll(",", "");

      if (newPayload.masterIncome)
        newPayload.masterIncome = newPayload.masterIncome.replaceAll(",", "");

      return newPayload;
    },
    async createANewTermicCourse() {
      try {
        this.isLoading = true;
        const _this = this;
        if (this.uploadImagePayload.imageFile) {
          await this.uploadTermicCourseImage();
        }
        const generatedPayload = _this.generateTermicCoursePayload();
        if (+generatedPayload.discountPrice > +generatedPayload.price) {
          return _this.$toast({
            component: ToastificationContent,
            props: {
              title: "ایجاد نشد!",
              icon: "XIcon",
              variant: "danger",
              text: "قیمت تخفیف خورده نمی‌تواند بیشتر از قیمت کلاس باشد.",
            },
          });
        }
        if (
            +generatedPayload.discountPriceConditionCount >=
            +generatedPayload.maxUserCapacity
        ) {
          return _this.$toast({
            component: ToastificationContent,
            props: {
              title: "ایجاد نشد!",
              icon: "XIcon",
              variant: "danger",
              text: "تعداد نفرات شامل تخفیف باید کمتر از حداکثر تعداد زبان آموز باشد.",
            },
          });
        }
        const createTermicCourse = new CreateTermicCourse(_this);
        createTermicCourse.setRequestParamDataObj(generatedPayload);
        await createTermicCourse.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کلاس ترمیک با موفقیت ایجاد شد.",
              },
            });
            if (_this.imagePreview) {
              _this.deletePreviewImage();
            }
            _this.termicCoursePayload = {
              termicCourseName: null,
              languageId: null,
              startDate: null,
              endDate: null,
              startTime: null,
              endTime: null,
              minUserCapacity: null,
              maxUserCapacity: null,
              sessions: null,
              masterUserId: null,
              price: null,
              discountPrice: null,
              discountPriceConditionCount: null,
              masterIncome: null,
              days: [],
              termicCourseDescription: null,
            };
          } else {
            if (res.errors?.isInterference) {
              this.conflicts = res.errors.interferences;
              this.$bvModal.show("conflict-modal");
            } else {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "ایجاد نشد!",
                  icon: "XIcon",
                  variant: "danger",
                  text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
                },
              });
            }
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    splitInto10MinIntervals(startStr, endStr) {
      const start = new Date(startStr);
      const end = new Date(endStr);
      const result = [];

      const pad = (n) => n.toString().padStart(2, "0");

      while (start < end) {
        const next = new Date(start.getTime() + 10 * 60 * 1000);
        const from = `${pad(start.getHours())}:${pad(start.getMinutes())}`;
        const to = `${pad(next.getHours())}:${pad(next.getMinutes())}`;
        result.push(`${from}-${to}`);
        start.setTime(next.getTime());
      }

      return result;
    },
  },
};
</script>

<style scoped>
.custom-image {
  max-height: 200px;
}
.custom-delete-btn {
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
}
</style>
